import { resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_view = _resolveComponent("router-view")!
  const _component_ShowToast = _resolveComponent("ShowToast")!
  const _component_DynamicDialog = _resolveComponent("DynamicDialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_router_view),
    _createVNode(_component_ShowToast),
    _createVNode(_component_DynamicDialog, { contentStyle: { padding: 0 } })
  ], 64))
}